module.exports = __webpack_public_path__ + "static/recommend-1505e3e51c4937bcddde0b67c414a12f.svg";